import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    TabContent,
    TabPane,
    Progress,
    NavLink,
    NavItem,
    Button,
    CardTitle,
    InputGroup,
    FormText,
    FormFeedback,
} from "reactstrap";
import moment from "moment";
import classnames from "classnames";
import { Link, Navigate } from "react-router-dom";
import Async from "react-select/async"
import "react-datetime/css/react-datetime.css";
import { getOrganisationsForAsyncSelect } from "../../../store/organisation/actions.js";
import {
    addMasterDeviceForm,
    clearCreateMasterDeviceError,
    copyMasterKeyToClipboard,
    createMasterDevice,
    createMasterDeviceKey,
    formatDeviceKeys,
    getUnassignedDevicesForAsyncSelect
} from "../../../store/device/actions.js";
import { getUsersForAsyncSelect } from "../../../store/actions.js";
import { SUPER_ADMIN } from "../../../store/users/role.constants.js";
import UITooltip from "../../../CommonData/Data/UITooltip";
import { connect } from "react-redux";
import Message from "../../../CommonData/Data/Message.js";
import { clearForm, updateForm } from "../../../store/form/actions.js";
import { DEFAULT_MASTER_DEVICE_SERIAL_NO } from "../../../store/device/actionTypes.js";
import VWLoading from "../../../components/vwLoading/vwLoading.js";

const FormWizard = (props) => {

    const { currentProfile, createMasterDeviceKey, masterDeviceKey, errorMessage, form, isCreateMasterDevicePending, selectedDeviceList } = props;
    const [new_user_organisation, setNewAddOrganisation] = useState("");
    const [selected_user, setNewUser] = useState("");
    const [activeTabwiz, setoggleTabwiz] = useState(1);
    const [passedStepswiz, setpassedStepswiz] = useState([1]);
    const [validationDate, setValidationDate] = useState();
    const [selectedDevice, setSelectedDevice] = useState({});
    const [deviceSNo, setDeviceSNo] = useState();
    const [maxSlave, setMaxSlave] = useState();

    const currentRole = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0]
    const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === SUPER_ADMIN;

    useEffect(() => {
        const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === SUPER_ADMIN;
        createMasterDeviceKey();
        if (!isSuperAdmin) {
            setNewAddOrganisation({
                label: currentRole.orgName,
                value: currentRole.orgId,
            });
        }
        props.updateForm({
            formAddDevice: {
                formAddDevice1: {},
                formAddDevice2: {
                    ...form && form.formAddDevice && form.formAddDevice.formAddDevice2,
                },
                errors1: {},
                errors2: {},
            }
        })

        props.clearCreateMasterDeviceError();
        return () => {
            props.clearCreateMasterDeviceError();
            props.clearForm();
        }
    }, []);

    //------------------------TAB-1-----------------------------------------------------------------------------------
    const handleInputChange = (event) => {
        const { name, value } = event.target;

        props.updateForm({
            formAddDevice: {
                ...form.formAddDevice,
                formAddDevice1: {
                    ...form.formAddDevice.formAddDevice1,
                    [name]: value
                },
                errors1: {
                    ...form && form.formAddDevice.errors1,
                    [name]: name === "friendlyName" && ((value && value.length) > 15) ? "Friendly name should not exceed 15 characters" : null,
                }
            }
        });
    }

    const copyToClipboard = () => {
        props.copyMasterKeyToClipboard(selectedDevice.uid);
    };

    const handleLoadUnAssignedDevices = (inputValue, callback) => {
        props.getUnassignedDevicesForAsyncSelect(inputValue, callback);
    };

    const handleAddMasterDeviceUnassignedChange = (value) => {
        const label = value && value.label;
        const sNo = label && label.split('|')[1].trim();
        setDeviceSNo(sNo);
        const finalSelectedDevice = selectedDeviceList && selectedDeviceList.filter((i) => i.id === value.value);
        const { subcriptionValidity, uid } = finalSelectedDevice[0] || {};
        setValidationDate(subcriptionValidity);
        setSelectedDevice({
            subcriptionValidity: subcriptionValidity,
            uid: uid,
        });
        setMaxSlave(value && value.slaveCountToConnect);
        props.updateForm({
            formAddDevice: {
                ...form.formAddDevice,
                formAddDevice1: {
                    ...form.formAddDevice.formAddDevice1,
                    selected_device: value,
                    uid: uid,
                },
                formAddDevice2: {
                    ...form.formAddDevice.formAddDevice2,
                    subscriptionValidity: subcriptionValidity
                },
                errors1: {
                    ...form && form.formAddDevice.errors1,
                    selected_device: null,
                }
            }
        });
    }
    //------------------------TAB-2-----------------------------------------------------------------------------------
    const handleInputChange2 = (event) => {
        const { name, value } = event.target;
        props.updateForm({
            formAddDevice: {
                ...form.formAddDevice,
                formAddDevice2: {
                    ...form.formAddDevice.formAddDevice2,
                    [name]: value
                },
                errors2: {
                    ...form && form.formAddDevice.errors2,
                    [name]: null,
                }
            }
        });
    }

    const handleLoadOrganisation = (inputValue, callback) => {
        props.getOrganisationsForAsyncSelect(inputValue, callback);
    };

    const handleLoadUsers = (inputValue, callback) => {
        const organisationId = new_user_organisation && new_user_organisation.value;
        if (organisationId) {
            props.getUsersForAsyncSelect(organisationId, inputValue, callback);
        }
        else {
            callback([]);
        }
    };

    const handleAddMasterDeviceOrgChange = (value) => {
        setNewAddOrganisation(value)
        props.updateForm({
            formAddDevice: {
                ...form.formAddDevice,
                formAddDevice2: {
                    ...form.formAddDevice.formAddDevice2,
                    new_user_organisation: value
                },
                errors2: {
                    ...form && form.formAddDevice.errors2,
                    new_user_organisation: null,
                }
            }
        });
    };

    const handleAddMasterDeviceUserChange = (value) => {
        setNewUser(value);
        props.updateForm({
            formAddDevice: {
                ...form.formAddDevice,
                formAddDevice2: {
                    ...form.formAddDevice.formAddDevice2,
                    selected_user: value
                },
                errors2: {
                    ...form && form.formAddDevice.errors2,
                    selected_user: null,
                }
            }
        });
    };

    const subscriptionChange = (e) => {
        const { value } = e.target;
        setValidationDate(value)
        props.updateForm({
            formAddDevice: {
                ...form.formAddDevice,
                formAddDevice2: {
                    ...form.formAddDevice.formAddDevice2,
                    subscriptionValidity: value
                },
                errors2: {
                    ...form && form.formAddDevice.errors2,
                    subscriptionValidity: null,
                }
            }
        });
    };
    //---------------------VALIDATION & PAGE NAVIGATION-----------------------------------------------------------
    const toggleTabwiz = (tab) => {
        const { formAddDevice } = form || {};
        const { formAddDevice1, formAddDevice2, errors1 } = formAddDevice || {};
        const { friendlyName, selected_device, } = formAddDevice1 || {};
        const { new_user_organisation, selected_user, subscriptionValidity, deviceKeys } = formAddDevice2 || {};

        let errors = {};
        const currentErrors1 = {};
        const currentErrors2 = {};
        let data;
        let SNoValidation;
        let slavesCount, isSlavesCountExceed;
        if (deviceKeys) {
            data = formatDeviceKeys(deviceKeys);
            SNoValidation = data && data.includes(deviceSNo);
            slavesCount = data && data.length;
            isSlavesCountExceed = maxSlave < slavesCount;
        }
        //---------------------TAB-1-----------------------------------------------------------
        if (activeTabwiz === 1) {
            if (!friendlyName) {
                currentErrors1.friendlyName = "Name is required"
            }
            if (errors1 && errors1.friendlyName) {
                currentErrors1.friendlyName = "Friendly name should not exceed 15 characters"
            }
            if (!selected_device) {
                currentErrors1.selected_device = "Device is required"
            }


            props.updateForm({
                formAddDevice: {
                    ...formAddDevice,
                    formAddDevice1: {
                        ...form.formAddDevice.formAddDevice1,
                    },
                    errors1: currentErrors1,
                }
            })

            errors = currentErrors1;
        }
        //---------------------TAB-2-----------------------------------------------------------
        if (activeTabwiz === 2) {
            if (!new_user_organisation && isSuperAdmin) {
                currentErrors2.new_user_organisation = "Organization is required"
            }
            if (!selected_user) {
                currentErrors2.selected_user = "User is required"
            }
            if (!subscriptionValidity) {
                currentErrors2.subscriptionValidity = "Subscription date is required"
            }

            if (isSlavesCountExceed) {
                currentErrors2.deviceKeys = `Slave device limit exceeded (max: ${maxSlave}).`
            }

            if (SNoValidation) {
                currentErrors2.deviceKeys = "Serial number is already used in device field. Please select another serial number."
            }
            props.updateForm({
                formAddDevice: {
                    ...formAddDevice,
                    formAddDevice2: {
                        ...form.formAddDevice.formAddDevice2,
                    },
                    errors2: currentErrors2,
                }
            })

            errors = currentErrors2
        }

        if (Object.keys(errors).length === 0) {
            if (activeTabwiz !== tab) {
                var modifiedSteps = [...passedStepswiz, tab];
                if (tab >= 1 && tab <= 3) {
                    setoggleTabwiz(tab);
                    setpassedStepswiz(modifiedSteps);
                }
            }
        }
        else {
            if (activeTabwiz > tab) {
                var modifiedSteps = [...passedStepswiz, tab];
                if (tab >= 1 && tab <= 3) {
                    setoggleTabwiz(tab);
                    setpassedStepswiz(modifiedSteps);
                }
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        props.createMasterDevice();
    }

    const renderSubscription = (props) => {
        return (
            <div className="input-group date">
                <Input
                    className="form-control"
                    name="subscriptionValidity"
                    onChange={handleInputChange}
                    data-validate='["required"]'
                    {...props}
                />
                <span className="input-group-append input-group-addon">
                    <span className="input-group-text fas fa-calendar-alt"></span>
                </span>
            </div>
        );
    };

    return props.isSuccess ? (<Navigate to="/devicelist/master-devices" />) : (
        <React.Fragment>
            <div className="page-content">
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardTitle className='m-2 d-flex justify-content-between align-items-center border-bottom border-secondary mb-0'>
                                <h5 className="fw-bold">CREATE MASTER DEVICE</h5>
                                <Link to='/devicelist/master-devices' className="text-dark">
                                    <i className="mdi mdi-close fs-2"></i>
                                </Link>
                            </CardTitle>
                            <CardBody>
                                {errorMessage && (
                                    <Message
                                        type="danger"
                                        defaultMessage={errorMessage}
                                        baseClassName="alert"
                                    />
                                )}
                                <div id="progrss-wizard" className="twitter-bs-wizard">
                                    <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                                        <NavItem className={classnames({ active: activeTabwiz === 1 })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 1 }))}
                                                onClick={() => toggleTabwiz(1)}
                                            >
                                                <span className="step-number">01</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>Master Device Details</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={classnames({ active: activeTabwiz === 2 })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 2 }))}
                                                onClick={() => toggleTabwiz(2)}
                                            >
                                                <span className="step-number">02</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>User Details</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={classnames({ active: activeTabwiz === 3 })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 3 }))}
                                                onClick={() => toggleTabwiz(3)}
                                            >
                                                <span className="step-number">03</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>Confirm Details</span>
                                            </NavLink>
                                        </NavItem>
                                    </ul>
                                    <div id="bar" className="mt-4">
                                        <div className="mb-4">
                                            <Progress
                                                value={40 * activeTabwiz}
                                                color="success"
                                                animated
                                            />
                                        </div>
                                    </div>
                                    <TabContent activeTab={activeTabwiz} className="twitter-bs-wizard-tab-content">
                                        <TabPane tabId={1}>
                                            <Form>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-firstname-input12">
                                                                Master Device Uid
                                                            </Label>
                                                            <InputGroup>
                                                                <Input
                                                                    type="text"
                                                                    className="border-secondary border-end-0"
                                                                    name="masterDevicekey"
                                                                    disabled
                                                                    value={selectedDevice.uid}
                                                                    onChange={handleInputChange}
                                                                />
                                                                <Button
                                                                    className="border-secondary border-start-0"
                                                                    type="button"
                                                                    color="light"
                                                                    onClick={copyToClipboard}
                                                                >
                                                                    <em className="fa fa-clipboard"></em>
                                                                </Button>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-lastname-input22">
                                                                Friendly Name<span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                autoFocus={true}
                                                                type="text"
                                                                name="friendlyName"
                                                                placeholder="Enter friendly name"
                                                                onChange={handleInputChange}
                                                                invalid={form && form.formAddDevice
                                                                    && form.formAddDevice.errors1 &&
                                                                    form.formAddDevice.errors1.friendlyName}
                                                            />
                                                            <FormFeedback>
                                                                {form && form.formAddDevice
                                                                    && form.formAddDevice.errors1 &&
                                                                    form.formAddDevice.errors1.friendlyName}
                                                            </FormFeedback>

                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-phoneno-input32">
                                                                Device<span className="text-danger">*</span>
                                                            </Label>
                                                            <Async
                                                                styles={{
                                                                    control: (baseStyles) => ({
                                                                        ...baseStyles,
                                                                        borderColor: (form && form.formAddDevice
                                                                            && form.formAddDevice.errors1 &&
                                                                            form.formAddDevice.errors1.selected_device) ? 'red' : ""
                                                                    })
                                                                }}
                                                                id="selected_device"
                                                                name="selected_device"
                                                                placeholder="Select device"
                                                                defaultOptions
                                                                loadOptions={handleLoadUnAssignedDevices}
                                                                onChange={handleAddMasterDeviceUnassignedChange}
                                                                openMenuOnFocus={true}
                                                                menuPortalTarget={document.body}
                                                            />
                                                            {(form && form.formAddDevice
                                                                && form.formAddDevice.errors1 &&
                                                                form.formAddDevice.errors1.selected_device) &&
                                                                <FormText sx={{ marginLeft: "10px" }}>
                                                                    <div className="text-danger">
                                                                        {form && form.formAddDevice
                                                                            && form.formAddDevice.errors2 &&
                                                                            form.formAddDevice.errors1.selected_device}
                                                                    </div>
                                                                </FormText>
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-email-input42">
                                                                Master Board Serial Number<span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                type="text"
                                                                name="boardSerialNumber"
                                                                placeholder="Enter board serial number"
                                                                onChange={handleInputChange}
                                                                value={DEFAULT_MASTER_DEVICE_SERIAL_NO}
                                                                disabled
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </TabPane>
                                        <TabPane tabId={2}>
                                            <div>
                                                <Form>
                                                    <Row>
                                                        <Col lg="6">
                                                            <FormGroup className="mb-3">
                                                                {isSuperAdmin && (
                                                                    <div className="form-group">
                                                                        <Label>
                                                                            Organization<span className="text-danger">*</span>
                                                                        </Label>
                                                                        <Async
                                                                            styles={{
                                                                                menu: (provided) => ({
                                                                                    ...provided,
                                                                                    zIndex: 9999,
                                                                                }),
                                                                                control: (baseStyles) => ({
                                                                                    ...baseStyles,
                                                                                    borderColor: (form && form.formAddDevice
                                                                                        && form.formAddDevice.errors2 &&
                                                                                        form.formAddDevice.errors2.new_user_organisation) ? 'red' : ""
                                                                                })
                                                                            }}
                                                                            id="new_user_organisation"
                                                                            name="new_user_organisation"
                                                                            placeholder="Select organization"
                                                                            isDisabled={!isSuperAdmin}
                                                                            defaultOptions
                                                                            loadOptions={handleLoadOrganisation}
                                                                            onChange={handleAddMasterDeviceOrgChange}
                                                                            openMenuOnFocus={true}
                                                                            menuPortalTarget={document.body}
                                                                            value={isSuperAdmin ? null : new_user_organisation}
                                                                        />
                                                                        {(form && form.formAddDevice
                                                                            && form.formAddDevice.errors2 &&
                                                                            form.formAddDevice.errors2.new_user_organisation) &&
                                                                            <FormText sx={{ marginLeft: "10px" }}>
                                                                                <div className="text-danger">
                                                                                    {form && form.formAddDevice
                                                                                        && form.formAddDevice.errors2 &&
                                                                                        form.formAddDevice.errors2.new_user_organisation}
                                                                                </div>
                                                                            </FormText>
                                                                        }
                                                                    </div>
                                                                )}
                                                                {((isSuperAdmin && new_user_organisation) || !isSuperAdmin) && (
                                                                    <FormGroup>
                                                                        <Label>
                                                                            User<span className="text-danger">*</span>
                                                                        </Label>
                                                                        <Async
                                                                            styles={{
                                                                                menu: (provided) => ({
                                                                                    ...provided,
                                                                                    zIndex: 9999,
                                                                                }),
                                                                                control: (baseStyles) => ({
                                                                                    ...baseStyles,
                                                                                    borderColor: (form && form.formAddDevice
                                                                                        && form.formAddDevice.errors2 &&
                                                                                        form.formAddDevice.errors2.selected_user) ? 'red' : ""
                                                                                })
                                                                            }}
                                                                            key={new_user_organisation}
                                                                            id="selected_user"
                                                                            name="selected_user"
                                                                            placeholder="Select user"
                                                                            defaultOptions
                                                                            loadOptions={handleLoadUsers}
                                                                            onChange={handleAddMasterDeviceUserChange}
                                                                            openMenuOnFocus={true}
                                                                            isDisabled={!new_user_organisation}
                                                                            value={selected_user}
                                                                            menuPortalTarget={document.body}
                                                                        />
                                                                        {(form && form.formAddDevice
                                                                            && form.formAddDevice.errors2 &&
                                                                            form.formAddDevice.errors2.selected_user) &&
                                                                            <FormText sx={{ marginLeft: "10px" }}>
                                                                                <div className="text-danger">
                                                                                    {form && form.formAddDevice
                                                                                        && form.formAddDevice.errors2 &&
                                                                                        form.formAddDevice.errors2.selected_user}
                                                                                </div>
                                                                            </FormText>
                                                                        }
                                                                    </FormGroup>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="6">
                                                            <FormGroup className="mb-3">
                                                                <Label>
                                                                    Subscription Validity<span className="text-danger">*</span>
                                                                </Label>
                                                                <Input
                                                                    type='date'
                                                                    dateFormat="DD-MM-YYYY"
                                                                    timeFormat={false}
                                                                    closeOnSelect={true}
                                                                    renderInput={renderSubscription}
                                                                    onChange={subscriptionChange}
                                                                    value={validationDate && validationDate.split('T')[0]}
                                                                    invalid={form && form.formAddDevice
                                                                        && form.formAddDevice.errors2 &&
                                                                        form.formAddDevice.errors2.subscriptionValidity}
                                                                />
                                                                {form && form.formAddDevice && form.formAddDevice.errors2 &&
                                                                    form.formAddDevice.errors2.subscriptionValidity &&
                                                                    < FormText>
                                                                        <div className='text-danger'>
                                                                            {form && form.formAddDevice && form.formAddDevice.errors2 &&
                                                                                form.formAddDevice.errors2.subscriptionValidity}
                                                                        </div>
                                                                    </FormText>
                                                                }
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg="6">
                                                            <FormGroup className="mb-3">
                                                                <Label>
                                                                    Serial Numbers &nbsp;&nbsp;
                                                                    <UITooltip
                                                                        content="Input methods: Range (x-y), Comma seperated (x,y), Single number x"
                                                                        id="addMasterDeviceSerialNos"
                                                                        key="addMasterDeviceSerialNos"
                                                                    >
                                                                        <i className="fas fa-info-circle"></i>
                                                                    </UITooltip>
                                                                </Label>
                                                                <Input
                                                                    type="textarea"
                                                                    name="deviceKeys"
                                                                    placeholder="Eg. 3; 5-8; 6,9"
                                                                    onChange={handleInputChange2}
                                                                    invalid={form && form.formAddDevice
                                                                        && form.formAddDevice.errors2 &&
                                                                        form.formAddDevice.errors2.deviceKeys}
                                                                />
                                                                <FormFeedback>
                                                                    {form && form.formAddDevice
                                                                        && form.formAddDevice.errors2 &&
                                                                        form.formAddDevice.errors2.deviceKeys}
                                                                </FormFeedback>
                                                                <span className="form-text">
                                                                    <b>TIP :</b> You can add multiple devices by separating them with
                                                                    comma or specify hyphen for range.
                                                                    <br />
                                                                </span>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>
                                        </TabPane>
                                        {/* <TabPane tabId={3}>
                                            <Form>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-vatno-input62">
                                                                AMC start Date
                                                            </Label><span className="text-danger">*</span>
                                                            <Input
                                                                type="date"
                                                                name="amcStartDate"
                                                                className="form-control"
                                                                id="basicpill-vatno-input62"
                                                                placeholder="Enter device AMC start date"
                                                                value={selectedDevice.amcStartDate && selectedDevice.amcStartDate.split('T')[0]}
                                                                disabled
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-vatno-input62">
                                                                AMC End Date
                                                            </Label><span className="text-danger">*</span>
                                                            <Input
                                                                type="date"
                                                                name="amcEndDate"
                                                                className="form-control"
                                                                id="basicpill-vatno-input62"
                                                                placeholder="Enter device AMC end date"
                                                                value={selectedDevice.amcEndDate && selectedDevice.amcEndDate.split('T')[0]}
                                                                disabled
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-vatno-input62">
                                                                AMC Status
                                                            </Label>
                                                            <Input
                                                                type="text"
                                                                name="amcStatus"
                                                                className="form-control"
                                                                id="basicpill-vatno-input62"
                                                                placeholder="Enter device AMC status"
                                                                value={selectedDevice.amcStatus}
                                                                disabled
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </TabPane> */}
                                        <TabPane tabId={3}>
                                            <div className="row justify-content-center">
                                                <Col lg="12">
                                                    {isCreateMasterDevicePending ? <VWLoading />
                                                        : <div className="text-center">
                                                            <div className="mb-4">
                                                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                            </div>
                                                            <div>
                                                                <h5>Confirm Details</h5>
                                                                <p className="text-muted">
                                                                    New master device is going to create as per your inputs. Are you sure to create?
                                                                </p>
                                                            </div>
                                                            <FormGroup>
                                                                <Button color="success" onClick={handleSubmit}>Submit</Button>
                                                                <Link className="btn btn-danger ms-4" to='/devicelist/master-devices'>
                                                                    Cancel
                                                                </Link>
                                                            </FormGroup>
                                                        </div>}
                                                </Col>
                                            </div>
                                        </TabPane>
                                    </TabContent>
                                    <ul className="pager wizard twitter-bs-wizard-pager-link">
                                        <li className={activeTabwiz === 1 ? "previous disabled me-2" : "previous me-2"}>
                                            {activeTabwiz !== 1 && <Button
                                                color='primary'
                                                onClick={() => toggleTabwiz(activeTabwiz - 1)}
                                                disabled={activeTabwiz === 1}>
                                                Previous
                                            </Button>}
                                        </li>
                                        <li className={activeTabwiz === 3 ? "next disabled" : "next"}>
                                            {activeTabwiz !== 3 && <Button
                                                color='primary'
                                                onClick={() => toggleTabwiz(activeTabwiz + 1)}
                                                disabled={activeTabwiz === 3}>
                                                Next
                                            </Button>
                                            }
                                        </li>
                                    </ul>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment >
    );
};

const mapStateToProps = (state) => ({
    form: state.form.form,
    isCreateMasterDevicePending: state.device.isCreateMasterDevicePending,
    isSuccess: state.device.isMasterCreateSuccess,
    errorMessage: state.device.errorMessage,
    currentProfile: state.login.currentProfile,
    masterDeviceKey: state.device.masterDeviceKey,
    AddDevice: state.device.AddDevice,
    errorMessage: state.device.errorMessage,
    selectedDeviceList: state.device.selectedDeviceList,
});

const mapDispatchToProps = (dispatch) => ({
    createMasterDeviceKey: () => dispatch(createMasterDeviceKey()),
    updateForm: (AddDevices) => dispatch(updateForm(AddDevices)),
    createMasterDevice: () => dispatch(createMasterDevice()),
    clearCreateMasterDeviceError: () => dispatch(clearCreateMasterDeviceError()),
    clearForm: () => dispatch(clearForm()),
    addMasterDeviceForm: (AddDevice) => dispatch(addMasterDeviceForm(AddDevice)),
    getOrganisationsForAsyncSelect: (searchValue, callback) => dispatch(getOrganisationsForAsyncSelect(searchValue, callback)),
    getUsersForAsyncSelect: (organisationId, searchValue, callback) => dispatch(getUsersForAsyncSelect(organisationId, searchValue, callback)),
    getUnassignedDevicesForAsyncSelect: (searchValue, callback) => dispatch(getUnassignedDevicesForAsyncSelect(searchValue, callback)),
    copyMasterKeyToClipboard: (masterDeviceKey) => dispatch(copyMasterKeyToClipboard(masterDeviceKey)),
    formatDeviceKeys: (masterDeviceKey) => dispatch(formatDeviceKeys(masterDeviceKey)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormWizard);